import { create, string, type } from 'superstruct';
export const Payload = type({
    note: string()
});
export const makeUpdateCartNote = function(agent) {
    return async function updateCartNote(rawPayload) {
        const { note  } = create(rawPayload, Payload);
        await agent.post('/cart/update.js', {
            json: {
                note
            }
        }).json();
    };
};
